import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../API/api';

// Fetch User Data
export const fetchUser = createAsyncThunk('user/fetchUser', async (_, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }
    console.log("Fetching user data from /user/me...");
    const response = await api.get('/user/me', {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 10000,
    });
    console.log("User Data:", response.data);
    return response.data;
  } catch (error) {
    console.log('Something went wrong while fetching user:', error);
    localStorage.removeItem('token');
    return rejectWithValue(error.response?.data?.message || 'Error fetching user');
  }
});

// Update User Data
export const updateUser = createAsyncThunk('user/updateUser', async (userData, { rejectWithValue, dispatch }) => {
  try {
    let formData = new FormData();
    let isFormData = false;

    if (userData.profile_image) {
      formData.append('profile_image', userData.profile_image);
      isFormData = true;
    }
    if (userData.username) formData.append('username', userData.username);
    if (userData.email) formData.append('email', userData.email);
    if (userData.password) formData.append('password', userData.password);

    const response = await api.put(`/user/me`, isFormData ? formData : userData, {
      headers: { 'Content-Type': isFormData ? 'multipart/form-data' : 'application/json' },
    });

    dispatch(fetchUser()); // Fetch updated user data after update
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Error updating user');
  }
});

// Delete User
export const deleteUser = createAsyncThunk('user/deleteUser', async (_, { rejectWithValue }) => {
  try {
    await api.delete(`/user/me`);
    return true;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Error deleting user');
  }
});

// User Slice
const userSlice = createSlice({
  name: 'user',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.data = null;
      state.error = null;
      localStorage.removeItem('token');
    },
    clearPersistedState: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
      })
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.data = null;
        state.error = null;
        state.loading = false;
      });
  },
});

export const { logout, clearPersistedState } = userSlice.actions;
export default userSlice.reducer;